module.exports = __webpack_public_path__ + "img/6.69ab2e3c.png";